import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import banner from "assets/images/banner_purple_bg.jpeg";

const TabContainer = ({ children, step = 1, totalSteps = 4 }) => {
  const theme = useContext(ThemeContext);

  return (
    <div
      style={{
        display: "flex",
        position: "relative",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <img
        src={banner}
        alt={"Banner"}
        style={{
          width: "100%",
          height: "119px",
          objectFit: "cover",
          borderRadius: 10,
          position: "absolute",
          top: 0,
          zIndex: 10,
        }}
      />
      <section
        style={{
          position: "absolute",
          top: 40,
          zIndex: 14,
          width: '100%',
          maxWidth: 800,
          borderWidth: 1,
          padding: "18px 24px",
          borderRadius: 10,
          borderStyle: "solid",
          borderColor: theme.newPalette.background.gray[300],
          backgroundColor: "#fff",
        }}
      >
        <header
          style={{
            gap: 12,
            width: "100%",
            display: "flex",
            paddingBottom: 28,
            paddingTop: 8,
          }}
        >
          {Array.from({ length: totalSteps }).map((_, index) => (
            <figure
              key={index}
              style={{
                height: 5,
                width: "100%",
                borderRadius: 20,
                backgroundColor:
                  step >= index + 1
                    ? theme.newPalette.background.purple
                    : theme.newPalette.background.gray[300],
              }}
            />
          ))}
        </header>
        {children}
      </section>
    </div>
  );
};

export default TabContainer;
